// Template-type colour palettes.
//
// Two palettes are kept deliberately separate so the surfaces can diverge:
//
//  - brandTypeStyle — the new brand-aligned categorical palette. Applied to the
//    Templates admin page and the template-requests portal. Hue groups the
//    document kind (warm ≈ policies, cool ≈ endorsements, neutral ≈ other docs);
//    the icon glyph still conveys the format. Includes chip bg/border tints.
//
//  - legacyTypeStyle — the historical palette, unchanged. It's the DEFAULT for
//    the shared FileIcon/FileDetail, so the super-admin templates console and any
//    other consumer keep their existing look untouched.
//
// FileIcon/FileDetail default to legacyTypeStyle; the brand surfaces pass
// brandTypeStyle explicitly.

const BRAND_TYPE_STYLE = {
  ENDORSEABLE_WORD_JINJA: { fg: "#0f766e", bg: "#e6f4f2", border: "#c4e6e1" },
  ENDORSABLE_PDF: { fg: "#a4551f", bg: "#fbeee2", border: "#f2d7bf" },
  WORD_JINJA_ENDORSEMENT: { fg: "#3f51b5", bg: "#eceffa", border: "#d5dcf2" },
  PDF_ENDORSEMENT: { fg: "#7c3aed", bg: "#f2ecfc", border: "#e0d2f7" },
  WORD_JINJA: { fg: "#2f6f9e", bg: "#e9f2f8", border: "#cfe2ef" },
  WORD: { fg: "#65676f", bg: "#eef0f3", border: "#dde2e8" },
  EXCEL: { fg: "#218058", bg: "#e7f4ec", border: "#cbe7d6" },
};

const BRAND_DEFAULT = { fg: "#65676f", bg: "#eef0f3", border: "#dde2e8" };

export const brandTypeStyle = (form) => BRAND_TYPE_STYLE[form] ?? BRAND_DEFAULT;

// Historical colours (icon + title only — no chips on those surfaces). Kept
// verbatim so the super-admin console and other consumers are unchanged.
const LEGACY_TYPE_STYLE = {
  EXCEL: { fg: "green" },
  WORD: { fg: "blue" },
  WORD_JINJA: { fg: "blue" },
  ENDORSEABLE_WORD_JINJA: { fg: "darkcyan" },
  WORD_JINJA_ENDORSEMENT: { fg: "magenta" },
  PDF_ENDORSEMENT: { fg: "firebrick" },
  ENDORSABLE_PDF: { fg: "firebrick" },
};

const LEGACY_DEFAULT = { fg: "lightslategrey" };

export const legacyTypeStyle = (form) =>
  LEGACY_TYPE_STYLE[form] ?? LEGACY_DEFAULT;
